module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_4_6.82785315.jpeg";